import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function login(_x, _x2) {
  return _login.apply(this, arguments);
}
function _login() {
  _login = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(mobile, passWord) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request('/loginService/login', METHOD.POST, {
            mobile: mobile,
            passWord: passWord
          }));
      }
    }, _callee);
  }));
  return _login.apply(this, arguments);
}
export function getRouter(_x3) {
  return _getRouter.apply(this, arguments);
}
function _getRouter() {
  _getRouter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(userId) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request('/loginService/getRouter', METHOD.POST, {
            userId: userId
          }));
      }
    }, _callee2);
  }));
  return _getRouter.apply(this, arguments);
}